import React from 'react';
import classNames from 'clsx';
import {Aggregation, Aggregations} from '../../../../search-types';
import {useTranslation} from 'react-i18next';
import {EditableTag} from '../../../../../common/editable-tag/editableTag';

type AggregationListProps = {
    aggregations: Aggregations;
};

export const AggregationList = React.memo((props: AggregationListProps) => {
    const {t} = useTranslation();
    if (!props || !props.aggregations) {
        return null;
    }
    const listAggregationValues = (groupTitle: string, aggregation: Aggregation) => {
        return Object.entries(aggregation.values).map(([itemTitle, values]) => {
            return (
                <div key={groupTitle + aggregation.aggregationIndex + itemTitle} className="document-tag">
                    <div className="tag-name cell aggregationSubtitle">{t('aggregations.labels.' + itemTitle)}</div>
                    {values.map((value) => (
                        <div
                            key={groupTitle + aggregation.aggregationIndex + itemTitle + value}
                            className="tag-value cell"
                        >
                            <EditableTag
                                key={value}
                                fieldType="line"
                                value={value}
                                onSubmit={() => console.log('not needed')}
                                onCancel={() => console.log('not needed')}
                                onUserValidation={() => console.log('not needed')}
                                onDelete={() => console.log('not needed')}
                                allowEditing={false}
                            />
                        </div>
                    ))}
                </div>
            );
        });
    };
    const showAggregations = Object.entries(props.aggregations).map(([groupTitle, aggregations]) => {
        const aggregationList = aggregations.slice();
        return (
            <div key={groupTitle}>
                <div className="aggregation-section">{t('aggregations.' + groupTitle)}</div>
                {aggregationList
                    .sort(function (a, b) {
                        return ('' + a.aggregationIndex).localeCompare('' + b.aggregationIndex, 'en', {numeric: true});
                    })
                    .map((aggregation) => {
                        return (
                            <div key={aggregation.aggregationIndex}>
                                <div className="aggregation-list">
                                    {t('aggregations.indexPrefix.' + groupTitle) + ' ' + aggregation.aggregationIndex}
                                </div>
                                {listAggregationValues(groupTitle, aggregation)}
                            </div>
                        );
                    })}
            </div>
        );
    });

    return <div className={classNames('document-infos', 'aggregation-tags')}>{showAggregations}</div>;
});
